export { default as AddContactScreen } from "./add-contact-screen"
import { AddContactScreenNavigationProps } from "./types"
import React from "react"
import AddContact from "./add-contact-screen"
import { PageRoot } from "~screens/page-root"


const AddContactScreen: React.FC<AddContactScreenNavigationProps> = () => {
  return (
    <PageRoot>
      <AddContact />
    </PageRoot>
  )
}

export default AddContactScreen
